// {event: 'data.submit', hitScope: { formData: { ... } } }
// {event: 'data.invalid', hitScope: { formData: { ... }, formError: 'there was an error' } }

export const formTrackingEventHitscope = (element, data, error) => {
  let hitscope = {
    form_name:
      typeof element !== 'string'
        ? element?.getAttribute('data-name')
        : element,
    form_data: data
  }
  if (error) {
    hitscope = { ...hitscope, form_error: error }
  }
  return hitscope
}

export const pageViewEventPageScope = data => {
  let pageScope = {
    url: data?.url,
    template: data?.template,
    website_version: data?.website_version
  }
  return pageScope
}
export const pageViewEventUserScope = data => {
  let userScope = {
    user_first_name: data?.first_name,
    user_last_name: data?.last_name,
    user_email: data?.user_email,
    user_phone_number: data?.user_phone_number,
    user_id: data?.user_id,
    gender: data?.gender,
    age: data?.age,
    locale: data?.locale,
    broker_id: data?.broker_id
  }
  return userScope
}

export const formatClientSideError = error => {
  let errorFields = []
  Object.keys(error).forEach(item => {
    errorFields.push({
      name: item,
      errors: error[item],
      warnings: []
    })
  })
  return {
    errorFields
  }
}

export const customClickTracking = (event, hitScope) => {
  return {
    element_name: event,
    ...hitScope
  }
}

export const eliminateNewLineCharFromString = str => {
  return str.replace('\n', ' ')
}
